var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 9.5,
    fill: "white",
    stroke: "#E2E4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0707 45.9451C56.1807 43.8899 52.9133 44.1748 51.3911 46.5062C49.8658 44.1709 46.5945 43.8923 44.7069 45.9498C43.1112 47.6895 43.2935 50.4239 44.9487 52.1066L50.8316 58.0857C51.1384 58.3972 51.6408 58.3972 51.9476 58.0857L57.832 52.1066C59.4904 50.4224 59.6704 47.684 58.0707 45.9451Z",
    fill: "#47B638"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0872 45.3479H30.2611C29.8283 45.3479 29.4785 44.9973 29.4785 44.5653C29.4785 44.1333 29.8283 43.7827 30.2611 43.7827H38.0872C38.52 43.7827 38.8698 44.1333 38.8698 44.5653C38.8698 44.9973 38.52 45.3479 38.0872 45.3479Z",
    fill: "#47B638"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1304 25H56.8696C58.596 25 60 26.404 60 28.1304V42.2174H58.4348V38.3043H25.5652V48.4783C25.5652 49.3415 26.2672 50.0435 27.1304 50.0435H39.6522V51.6087H27.1304C25.404 51.6087 24 50.2047 24 48.4783V28.1304C24 26.404 25.404 25 27.1304 25ZM25.5664 32.0434H58.436V28.1304C58.436 27.2672 57.734 26.5652 56.8708 26.5652H27.1316C26.2684 26.5652 25.5664 27.2672 25.5664 28.1304V32.0434Z",
    fill: "#47B638"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon3);
export default __webpack_public_path__ + "static/media/service-icon3.569f68fc03fd35fa98b6b11c9775713e.svg";
export { ForwardRef as ReactComponent };